import { render, staticRenderFns } from "./upazila.vue?vue&type=template&id=d313054c&"
import script from "./upazila.vue?vue&type=script&lang=js&"
export * from "./upazila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports